

module.exports = __webpack_require__.stylable.create(
    "EventContainer4242051721",
    {"classes":{"root":"EventContainer4242051721__root"},"vars":{},"stVars":{"BorderWidth":"'\"unit(fallback(--cellBorderWidth, 1), px)\"'","EventWidth":"\"calculate(-, 100%, 28px)\""},"keyframes":{}},
    "",
    1,
    "EventContainer4242051721",
    null
);
